import { ConfigProvider, Input, InputNumber, Select, message } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { createOrUpdatePolicyDataTransferAgree, getAppleUserData } from "../../../../service";
import { requestSmsAuthSend } from "../../../../service";
import { requestSendAuthCodeCheck } from "../../../../service";
import { requestSignup } from "../../../../service";
import { updateSocialProfile } from "../../../../service";
import countryCodeList from '../CounrtyCodeList';
import { usePostSocialLogin } from "../../../../features/auth/usePostSocialLogin";
import AppleLoginMobileAppCallbackSkeleton from "../../../../components/skeleton/appleLogin/appleLoginMobileAppCallbackSkeleton";
import { TopBar } from "../../../../widgets";
import { ReactComponent as ArrowDownV2 } from "../../../../assets/images/icon/arrowDownV2.svg";
import NickNameCreateAndUpdateInput from "../../../my/setting/ui/nickNameCreateAndUpdateInput";
import PolicyDataTransferContainer from "../../../../features/policDataTransfer";
import PolicyDataTransfer from "../../../../components/modal/policyDataTransfer";
import { isIOS } from "react-device-detect";
import { clearAppleSignupHint, formatPhoneNumber, getAppleSignupHint } from "../../../../utils";
import { useCountdown } from "../../../../utils/useCountDown";
import { BottomSheet } from "../../../../shared";
import dayjs from "dayjs";
import Lottie from "lottie-react";
import LoadingBig from '../../../../assets/images/lottie/loading_big.json';
import './index.css'

const AppleLoginMobileAppCallback = () => {
    // Apple 로그인 시 네이티브에서 받아 둔 이름/이메일 — 사용자에게 다시 입력받지 않고 그대로 채운다.
    const [appleSignupHint] = useState(() => getAppleSignupHint());
    const [isInitLoading, setIsInitLoading] = useState<boolean>(true);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const code = searchParams.get("code");
    const { remainingTime, start } = useCountdown(180);
    const { redirectPath, isPolicyModalOpen, finishLogin, goBackToBeforeLogin } = usePostSocialLogin();
    const [socialAccessToken, setSocialAccessToken] = useState<string>('');
    const [sub, setSub] = useState<string>('');
    const [isCooldown, setIsCooldown] = useState(false);
    const [yearValue, setYearValue] = useState<number>();
    const [monthOpen, setMonthOpen] = useState<boolean>(false);
    const [monthValue, setMonthValue] = useState<number>();
    const [dayOpen, setDayOpen] = useState<boolean>(false);
    const [dayValue, setDayValue] = useState<number>();
    const [isNickNameValid, setIsNickNameValid] = useState<boolean>(false);
    const [name, setName] = useState<string | undefined>(appleSignupHint.name || undefined);
    const [nickName, setNickName] = useState<string>('');
    const [countryCode, setCountryCode] = useState<string>('82');
    const [mobile, setMobile] = useState<string>();
    const [checkedCountryCode, setCheckedCountryCode] = useState<string>('82');
    const [checkedmobile, setCheckedMobile] = useState<string>();
    const [authCode, setAuthCode] = useState<string>('');
    const [isSendAuthCode, setIsSendAuthCode] = useState<boolean>(false);
    const [isAuthSuccess, setIsAuthSuccess] = useState<boolean>(false);
    const [agreememt, setAgreememt] = useState<[boolean, boolean, boolean]>([false, false, false]);
    const [validateFields, setValidateFields] = useState<[boolean, boolean, boolean, boolean, boolean]>([false, false, false, false, false]);
    const [sginUpLoading, setSginUpLoading] = useState<boolean>(false);
    const [email, setEmail] = useState<string | undefined>(appleSignupHint.email || undefined);

    const months = Array.from({ length: 12 }, (_, i) => {
        const month = i + 1;
        return { id: month, value: month, label: `${month}` };
    });

    const getDays = (year?: number, month?: number) => {
        const baseDate = year && month
            ? dayjs(`${year}-${month}-01`)
            : dayjs();

        const totalDays = baseDate.daysInMonth();
        return Array.from({ length: totalDays }, (_, i) => {
            const day = i + 1;
            return { id: day, value: day, label: `${day}` };
        });
    }

    useEffect(() => {
        if (!code) return navigate("/login");
        getAppleUserData(code)
            .then((res) => {
                if (res.data.message === '해당 아이디로는 가입이 불가능합니다.' || res.data.message.includes("가입되어 있습니다")) {
                    clearAppleSignupHint();
                    alert(res.data.message);
                    navigate('/login', { replace: true })
                } else if (res.data.message === '로그인 성공했습니다.') {
                    clearAppleSignupHint();
                    updateSocialProfile(res.data.sub, res.data.token)
                        .then(() => finishLogin())
                        .catch((error) => console.error('error', error))
                        .finally(() => setIsInitLoading(false));
                } else if (res.data.message === '회원가입을 진행해주세요.') {
                    // 서버가 id_token에서 뽑은 이메일이 우선, 비어 있으면 네이티브가 넘겨준 값으로 채운다.
                    setEmail(res.data.email || appleSignupHint.email || undefined);
                    setSocialAccessToken(res.data.token);
                    setSub(res.data.sub);
                    setIsInitLoading(false);
                }
            })
            .catch((error) => {
                clearAppleSignupHint();
                message.error("서버에 에러가 발생했습니다.");
                navigate('/login', { replace: true });
                console.error('error', error)
            })
            .finally(() => setIsInitLoading(false));
    }, [code])

    const onFinish = () => {
        if (!isAuthSuccess) {
            alert("모바일 인증이 필요합니다.");
            return;
        }

        if (!name || !checkedmobile || sginUpLoading) return;

        const birthyear = yearValue ?? 0;
        const monthStr = monthValue ? monthValue.toString().padStart(2, '0') : '';
        const dayStr = dayValue ? dayValue.toString().padStart(2, '0') : '';
        const birthday = monthStr + '-' + dayStr;


        const signUpRequest = {
            name: name,
            gender: '',
            mobile: checkedmobile.replaceAll('-', ''),
            email: email ?? '',
            birthday: birthday,
            birthyear: birthyear,
            nickname: nickName,
            socialAccessToken: socialAccessToken,
            social: 'APPLE',
            sub: sub,
        }
        setSginUpLoading(true)
        requestSignup(signUpRequest)
            .then(() => {
                // 가입이 끝나면 hint의 역할도 끝난다. 뒤따르는 약관 동의 API가 실패하더라도 남기지 않는다.
                clearAppleSignupHint();
                return createOrUpdatePolicyDataTransferAgree({
                    isAgree: agreememt.every(i => i),
                    isServiceUseTermAgree: agreememt[0],
                    isPersonInfoPolicyAgree: agreememt[1],
                    isMarketingAgreementAgree: agreememt[2]
                })
                    .then(() => goBackToBeforeLogin())
                    .catch((error) => { console.error('err', error); })
            })
            // 로딩을 풀어 주지 않으면 진입부의 sginUpLoading 가드에 걸려 가입 버튼이 영영 눌리지 않는다.
            .catch((error) => {
                message.error("회원가입에 실패했습니다. 잠시 후 다시 시도해주세요.");
                console.error('err', error);
            })
            .finally(() => setSginUpLoading(false))
    }

    const clickSendAuthMessage = () => {
        if (isCooldown) return;
        if (!mobile || !countryCode) return;
        setIsCooldown(true);
        setTimeout(() => {
            setIsCooldown(false);
        }, 3000);
        setCheckedCountryCode(countryCode)
        setCheckedMobile(mobile)
        setIsSendAuthCode(true);
        requestSmsAuthSend(countryCode, mobile)
            .then((res) => { start() })
            .catch((error) => console.error('error', error));
    }

    const clickSendAuthCodeCheck = () => {
        if (isAuthSuccess) return;
        requestSendAuthCodeCheck(authCode)
            .then((res) => setIsAuthSuccess(res.data))
            .catch((error) => console.error('error', error));
    }

    const validateSignInAndAgreement = () => {
        return agreememt.every((q, idx) => idx === 2 || q) && validateFields.every(q => q)
    }

    useEffect(() => {
        setValidateFields([!!name, !!isNickNameValid, !!countryCode, !!mobile, !!isAuthSuccess])
    }, [name, isNickNameValid, countryCode, mobile, isAuthSuccess])

    return <>
        <PolicyDataTransfer propsModalStatus={isPolicyModalOpen} beforeUrl={redirectPath} />
        {isInitLoading
            ? <AppleLoginMobileAppCallbackSkeleton />
            : <>
                <TopBar title="회원가입" rightIcon={false} position='fixed' thema='dark' />
                <div style={{ paddingInline: '20px', paddingBottom: isIOS ? '34px' : '20px' }}>
                    <div className="sub-title/st3" style={{ marginBlock: '24px' }}>
                        회원 정보를 입력해 주세요
                    </div>

                    <div style={{ marginBottom: '24px' }}>
                        <div className="sub-title/st2 " style={{ marginBottom: '8px' }}>이름<span style={{ color: 'var(--errore400)' }}>*</span></div>
                        <Input className="custom-input-apple body/b2" style={{ border: '1px solid var(--secondarys300, #D9D9D9)', borderRadius: '4px', padding: '8px 12px' }} onChange={(e) => setName(e.target.value)} value={name} placeholder="이름을 입력해주세요" />
                        {!!appleSignupHint.name &&
                            <div className="body/b1 secondary/s500" style={{ marginTop: '8px' }}>
                                Apple 계정에서 가져왔어요. 필요하면 수정할 수 있습니다.
                            </div>}
                    </div>

                    <div style={{ marginBottom: '24px' }}>
                        <div className="sub-title/st2 " style={{ marginBottom: '8px' }}>닉네임<span style={{ color: 'var(--errore400)' }}>*</span></div>
                        <NickNameCreateAndUpdateInput
                            style={{ border: '1px solid var(--secondarys300, #D9D9D9)', borderRadius: '4px', padding: '8px 12px', margin: 0 }}
                            className="custom-input-apple"
                            customPlaceholder="3글자 이상 입력해주세요"
                            nickName={nickName}
                            setNickName={setNickName}
                            isOnlyInput
                            isShowSaveBtn={false}
                            getNickNameDetailWebEnabled={false}
                            setPropsNickNameValid={setIsNickNameValid} />
                    </div>

                    <div style={{ marginBottom: '24px' }}>
                        <div className="sub-title/st2 " style={{ marginBottom: '8px' }}>국가선택<span style={{ color: 'var(--errore400)' }}>*</span></div>
                        <ConfigProvider
                            theme={{
                                components: {
                                    Select: {
                                        optionSelectedBg: 'var(--secondarys100)'
                                    },
                                },
                            }}
                        >
                            <Select
                                styles={{ popup: { root: { maxWidth: '440px', width: 'calc(100vw - 40px)' } } }}
                                variant={'borderless'}
                                style={{ width: '100%', height: '40px', border: '1px solid var(--secondarys300, #D9D9D9)', borderRadius: '4px' }}
                                value={countryCode}
                                className="custom-select-apple"
                                defaultValue={countryCode}
                                options={countryCodeList}
                                onChange={(value: string) => setCountryCode(value)}
                                suffixIcon={<ArrowDownV2 width={16} height={16} stroke={"#AEAEAE"} />}
                            />
                        </ConfigProvider>
                    </div>

                    <div style={{ marginBottom: '24px' }}>
                        <div className="sub-title/st2 " style={{ marginBottom: '8px' }}>휴대폰번호<span style={{ color: 'var(--errore400)' }}>*</span></div>
                        <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                            <Input className="custom-input-apple body/b2" placeholder="숫자만 입력해주세요." onChange={(e) => setMobile(e.target.value?.startsWith('0') ? e.target.value : '0' + e.target.value)} value={formatPhoneNumber(mobile ?? '')} style={{ flex: '73.43', border: '1px solid var(--secondarys300, #D9D9D9)', borderRadius: '4px', padding: '8px 12px' }} />
                            <div className="sub-title/st2 secondary/s600" onClick={clickSendAuthMessage} style={{ paddingBlock: '10.5px', textAlign: 'center', flex: '26.57', border: '1px solid var(--secondarys400, #AEAEAE)', borderRadius: '4px' }} >{isSendAuthCode ? '재전송' : '인증번호'}</div>
                        </div>
                        <div className="body/b1 secondary/s500">
                            통신사에 따라 최대 1분까지 소요될 수 있습니다.
                        </div>
                    </div>

                    <div style={{ marginBottom: '24px' }}>
                        <div className="sub-title/st2 " style={{ marginBottom: '8px' }}>인증번호 입력<span style={{ color: 'var(--errore400)' }}>*</span></div>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <Input className="custom-input-apple body/b2" placeholder="인증번호 6자리" onChange={(e) => setAuthCode(e.target.value)} value={authCode} defaultValue={authCode} style={{ flex: '73.43', border: '1px solid var(--secondarys300, #D9D9D9)', borderRadius: '4px', padding: '8px 12px' }} suffix={!isAuthSuccess && isSendAuthCode && remainingTime} />
                            <div className={"sub-title/st2 " + (isAuthSuccess ? 'secondary/s200' : 'secondary/s600')} onClick={clickSendAuthCodeCheck} style={{ paddingBlock: '10.5px', textAlign: 'center', flex: '26.57', border: `1px solid var(--${isAuthSuccess ? 'secondarys200' : 'secondarys400'}, #AEAEAE)`, borderRadius: '4px', }} >{isAuthSuccess ? '인증완료' : '인증확인'}</div>
                        </div>
                    </div>

                    <div style={{ marginBottom: '24px' }}>
                        <div className="sub-title/st2 " style={{ marginBottom: '8px' }}>생년월일</div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <InputNumber className="custom-input-apple body/b2" style={{ width: '33%', paddingBlock: '3px', border: '1px solid var(--secondarys300, #D9D9D9)', borderRadius: '4px', }} value={yearValue} onChange={q => setYearValue(Number(q))} placeholder="년" />
                            <BottomSheet classNames={{ textBtnClassNames: { children: 'body/b2 ' + (monthValue ? 'base/black' : 'secondary/s400') } }} clearLabel={monthValue ?? '월'} value={monthValue} setValue={q => setMonthValue(q)} isShowLabel isOpen={monthOpen} setIsOpen={setMonthOpen} dataList={months} styles={{ modalContent: { borderRadius: '16px 16px 0 0' }, clearLabelStyle: { width: '33%', border: '1px solid var(--secondarys300, #D9D9D9)', borderRadius: '4px', color: 'var(--secondarys400)' }, textBtnStyle: { width: '33%', border: '1px solid var(--secondarys300, #D9D9D9)', borderRadius: '4px' }, textBtnStyles: { container: { padding: '8px 12px', justifyContent: 'space-between' }, icon: { stroke: 'var(--secondarys400)' } } }} decreaseHeight={48} />
                            <BottomSheet classNames={{ textBtnClassNames: { children: 'body/b2 ' + (dayValue ? 'base/black' : 'secondary/s400') } }} clearLabel={dayValue ?? '일'} value={dayValue} setValue={q => setDayValue(q)} isShowLabel isOpen={dayOpen} setIsOpen={setDayOpen} dataList={getDays(yearValue, monthValue)} styles={{ modalContent: { borderRadius: '16px 16px 0 0' }, clearLabelStyle: { width: '33%', border: '1px solid var(--secondarys300, #D9D9D9)', borderRadius: '4px', color: 'var(--secondarys400)' }, textBtnStyle: { width: '33%', border: '1px solid var(--secondarys300, #D9D9D9)', borderRadius: '4px' }, textBtnStyles: { container: { padding: '8px 12px', justifyContent: 'space-between' }, icon: { stroke: 'var(--secondarys400)' } } }} decreaseHeight={48} />
                        </div>
                    </div>

                    <PolicyDataTransferContainer setAgreememtList={setAgreememt} />
                    <div className="sub-title/st3"
                        style={{
                            width: "100%", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px", paddingBlock: '16px',
                            background: validateSignInAndAgreement() ? "var(--baseblack)" : "var(--secondarys200)", color: validateSignInAndAgreement() ? "var(--basewhite)" : "var(--secondarys400)",
                        }}
                        onClick={onFinish}>
                        회원가입
                        {sginUpLoading && <Lottie style={{ width: 16, height: 16, paddingBlock: '1.5px', marginLeft: '8px' }} animationData={LoadingBig} autoplay={true} />}
                    </div>
                </div>
            </>}
    </>
}

export default AppleLoginMobileAppCallback;
